/* Aksesoris BAWAAN set — bukan stok, bukan barang berbayar.
   Hanya daftar "set ini keluar bersama apa" supaya saat barang kembali bisa dicek.

   Bawahan (sarung / songket / rok) TIDAK ada di sini: bawahan punya kode dan stok
   sendiri lewat kolom Bawahan. Gelang, bando, dan aksesoris tambahan yang berbayar
   ditambahkan lewat menu tambah barang.

   DAFTAR INI HARUS SAMA dengan AKSESORIS_SET di backend/server.py.
   Dijaga oleh uji/uji_aksesoris.py — kalau salah satu diubah, ubah dua-duanya. */
export const AKSESORIS_SET = {
  'Baju Bodo': ['Jilbab', 'Kalung'],
  'Kebaya': ['Jilbab'],
  'Jas Tutup': ['Songkok', 'Ikat pinggang'],
};

/* Aksesoris bawaan untuk satu kategori ([] kalau kategorinya tidak punya). */
export function aksesorisUntuk(kategori) {
  return AKSESORIS_SET[kategori] || [];
}
